import HashAgencyRequests from "app/api/hash-agency";
import { handleGenericApiError } from "app/api/error";
import { addLoading, removeLoading } from "./loading";
import { message } from "antd";
import { I18n } from "react-redux-i18n";

export const ACTION_SAVE_TOTAL_HASH_AGENCY =
  "hashAgency:ACTION_SAVE_TOTAL_HASH_AGENCY";
export const ACTION_SAVE_HASH_AGENCY = "hashAgency:ACTION_SAVE_HASH_AGENCY";

export const fetchTotalHashAgency = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await HashAgencyRequests.fetchTotalHashAgency(params);
    dispatch({ type: ACTION_SAVE_TOTAL_HASH_AGENCY, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const downloadHashTotalsCSV = params => async () => {
  if (params.searchParameter?.InitialDate && params.searchParameter?.EndDate) {
    var initialDate = params.searchParameter?.InitialDate.split(" ");
    var endDate = params.searchParameter?.EndDate.split(" ");
    initialDate = new Date(initialDate[0]);
    endDate = new Date(endDate[0]);
    var totalDaysDiff = Math.abs(endDate - initialDate) / (1000 * 60 * 60 * 24);
    if (totalDaysDiff < 185) {
      try {
        const response = await HashAgencyRequests.downloadHashTotalsCSV(
          params.searchParameter
        );
        const link = document.createElement("a");
        link.href = response.data;
        link.setAttribute("download", "hash.csv");
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        handleGenericApiError(err);
      }
    } else {
      message.info(I18n.t("errors.DATE_FILTER_PERIOD_INVALID"));
      return false;
    }
  } else {
    message.info(I18n.t("errors.DATE_FILTER_ERROR"));
    return false;
  }
};

export const fetchHashAgency = params => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await HashAgencyRequests.fetchHashAgency(params);
    dispatch({ type: ACTION_SAVE_HASH_AGENCY, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const downloadHashCSV = params => async () => {
  if (params.searchParameter?.InitialDate && params.searchParameter?.EndDate) {
    var initialDate = params.searchParameter?.InitialDate.split(" ");
    var endDate = params.searchParameter?.EndDate.split(" ");
    initialDate = new Date(initialDate[0]);
    endDate = new Date(endDate[0]);
    var totalDaysDiff = Math.abs(endDate - initialDate) / (1000 * 60 * 60 * 24);
    if (totalDaysDiff < 185) {
      try {
        const response = await HashAgencyRequests.downloadHashCSV(
          params.searchParameter
        );
        const link = document.createElement("a");
        link.href = response.data;
        link.setAttribute("download", "hash.csv");
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        handleGenericApiError(err);
      }
    } else {
      message.info(I18n.t("errors.DATE_FILTER_PERIOD_INVALID"));
      return false;
    }
  } else {
    message.info(I18n.t("errors.DATE_FILTER_ERROR"));
    return false;
  }
};
